'use strict';

import Constants from '../constants.js';
import ObjectAssign from 'object-assign';

const initialState = {
    hydrated: false,
    loading: false,
    error: undefined,
    errorMessage: undefined,
    hasError: {},
    help: {},
    token: undefined
};
const reducer = function (state = initialState, action) {

    if (action.type === Constants.GET_BT_TOKEN) {

        return ObjectAssign({}, state, {
            loading : true,
            hydrated : false
        });

    }

    if (action.type === Constants.GET_BT_TOKEN_RESPONSE) {

        if ( !action.err) {
            return ObjectAssign({}, state, {
                token : action.response.clientToken,
                loading: false,
                hydrated: true
            });
        }

        return ObjectAssign({}, state, {
            error : action.err,
            errorMessage: action.response.message,
            loading: false,
            hydrated: false
        });
    }

    return state;
};


export default reducer;
